import { AashtowareApiModel } from '../../../types/models/aashtoware.model';
import { CreateAashtowareApiRequest } from '../../../types/requests/aashtoware/create-aashtoware.request';
import { DeleteAashtowareApiRequest } from '../../../types/requests/aashtoware/delete-aashtoware.request';
import { GetAashtowareApiRequest } from '../../../types/requests/aashtoware/get-aashtoware.request';
import { SearchAashtowareApiRequest } from '../../../types/requests/aashtoware/search-aashtoware.request';
import { UpdateAashtowareApiRequest } from '../../../types/requests/aashtoware/update-aashtoware.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createAashtoware = (params: CreateAashtowareApiRequest) => client.post<AashtowareApiModel>('/aashtoware', params);

export const updateAashtoware = ({ aashtowareId, ...params }: UpdateAashtowareApiRequest) =>
  client.patch<AashtowareApiModel>(`/aashtoware/${aashtowareId}`, params);

export const getAashtoware = <T extends AashtowareApiModel>({ aashtowareId, ...params }: GetAashtowareApiRequest) =>
  client.get<T>(`/aashtoware/${aashtowareId}`, { params });

export const searchAashtoware = <T extends AashtowareApiModel>(params: SearchAashtowareApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/aashtoware`, { params });

export const deleteAashtoware = ({ aashtowareId }: DeleteAashtowareApiRequest) => client.delete<void>(`/aashtoware/${aashtowareId}`);
